import { ref } from 'vue';

export const openDropdownInstance = ref<(() => void) | null>(null);
